import { WebglSettingsConverter } from "./webgl-settings-converter";

export class CanvasWebglSettingsConverter extends WebglSettingsConverter {
  constructor(viewObjectConverters) {
    super();
    this.viewObjectConverters = viewObjectConverters;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    if (settings.items !== undefined && this.viewObjectConverters !== undefined && this.viewObjectConverters.size > 0) {
      settingsCopy.items = [];
      for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
        let itemSettings = settings.items[itemIndex];
        let objConverter = this.viewObjectConverters.get(itemSettings.type);
        if (objConverter !== undefined) {
          let convertedItemSettings = objConverter.convert(itemSettings);
          if (convertedItemSettings !== undefined) {
            settingsCopy.items.push(convertedItemSettings);
          }
        }
      }
    }
    return settingsCopy;
  }
}
